<template>
  <div>
    <div class="detail-content">
      <div class="content-head">
        <img src="/image/notice2.png" alt />
        <span>{{secondaryColName}}</span>
      </div>
      <div class="content-body" :class="{noP:noP==true}">
        <div class="head-text">
          <!-- <p>向全国广大教习近平致信全国优秀教师代表 向全国广大教向全国广大教向全国广大教向全国广大教</p> -->
          <p>{{title}}</p>
        </div>
        <div class="data-text">
          <span>发布时间：{{data!=null?data.split("T")[0]:'暂无信息'}}</span>
          <span>{{viewCount}}次浏览</span>
          <span v-if="infoSource">信息来源：本站</span>
          <span v-else>信息来源：外部</span>
        </div>
        <!-- <div > -->
        <!-- <p>习近平致信全国优秀教师代表强调</p>
          <p>大力弘扬教育家精神</p>
          <p>为强国建设民族复兴伟业作出新的更大贡献</p>
          <p>
            向全国广大教师和教育工作者致以节日问候和诚挚祝福
            李强作出批示 丁薛祥出席全国优秀教师代表座谈会并讲话
            全国优秀教师代表座谈会9月9日在京召开。
          </p>
          <br />
          <p>
            中共中央总书记、国家主席、中央军委主席习近平致信与会教师代表，在第三十九个教师节到来之际，代表党中央，向他们和全国广大教师及教育工作者致以节日的问候和诚挚的祝福。
            习近平在信中说，长期以来，以你们为代表的全国广大教师认真贯彻党的教育方针，教书育人、培根铸魂，培养了一代又一代德智体美劳全面发展的社会主义建设者和接班人，造就了大批可堪大用、能担重任的栋梁之才，为国家发展、民族振兴作出了重要贡献。教师群体中涌现出一批教育家和优秀教师，他们具有心有大我、至诚报国的理想信念，言为士则、行为世范的道德情操，启智润心、因材施教的育人智慧，勤学笃行、求是创新的躬耕态度，乐教爱生、甘于奉献的仁爱之心，胸怀天下、以文化人的弘道追求，展现了中国特有的教育家精神。
            习近平强调，新征程上，希望你们和全国广大教师以教育家为榜样，大力弘扬教育家精神，牢记为党育人、为国育才的初心使命，树立“躬耕教坛、强国有我”的志向和抱负，自信自强、踔厉奋发，为强国建设、民族复兴伟业作出新的更大贡献。
            中共中央政治局常委、国务院总理李强作出批示指出，教师是立教之本、兴教之源，是教育发展的第一资源。党的十八大以来，党中央和国务院高度重视教师队伍建设，教师队伍素质不断提升，结构不断优化，待遇不断提高，教师队伍建设取得历史性成就，为党和国家培育了大批优秀人才，为我国教育事业发展作出了突出贡献。要坚持以习近平新时代中国特色社会主义思想为指导，深刻领会习近平总书记重要指示和党的二十大精神，大力弘扬教育家精神，培养高素质教师队伍，健全中国特色教师教育体系，提升教书育人能力，优化教师管理和资源配置，加大待遇保障力度，完善荣誉表彰体系，营造全社会尊师重教浓厚氛围，让教师成为最受社会尊重和令人羡慕的职业，为加快建设教育强国、实现中华民族伟大复兴提供有力支撑。
            中共中央政治局常委、国务院副总理丁薛祥出席会议，传达习近平致信和李强批示并讲话。
            丁薛祥在讲话中表示，习近平总书记作出重要指示，李强总理作出批示，充分体现了党中央和国务院对广大教师的关心和重视。习近平总书记的重要指示，充分肯定广大教师为国家发展、民族振兴作出的重要贡献，深刻阐释教育家精神的丰富内涵和实践要求，赋予新时代人民教师崇高使命。希望广大教师认真贯彻党的教育方针，大力弘扬教育家精神，潜心教书育人、培根铸魂，持续为国家培养德智体美劳全面发展的社会主义建设者和接班人，造就更多可堪大用、能担重任的栋梁之才。要坚定心有大我、至诚报国的理想信念，全面落实立德树人根本任务；陶冶言为士则、行为世范的道德情操，努力做“经师”和“人师”相统一的“大先生”；涵养启智润心、因材施教的育人智慧，让每个学生都有人生出彩的机会；秉持勤学笃行、求是创新的躬耕态度，成为终身学习的践行者；勤修乐教爱生、甘于奉献的仁爱之心，用大爱书写教育人生；树立胸怀天下、以文化人的弘道追求，弘扬全人类共同价值。
            丁薛祥强调，各地各部门要把教师队伍建设作为基础工作，健全中国特色教师教育体系，培养造就一大批高质量的教师；依法保障教师待遇，吸引和稳定优秀人才从教；优化教师管理与结构配置，让每个孩子都能享有公平而有质量的教育；坚持师德师风第一标准，全面落实新时代教师职业行为准则；营造尊师重教社会风尚，让“人民教师，无上光荣”的观念深入人心。
        </p>-->
        <div v-html="content" class="body-text"></div>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { reqDetail } from "@/api";

export default {
  //给组件起一个名字,开发者工具中显示这个组件的时候，显示的就是这个名字
  // eslint-disable-next-line vue/multi-word-component-names
  name: "detailBox",
  props: {
    noP: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      content: "",
      title: "",
      data: "",
      viewCount: "",
      infoSource: "",
      secondaryColName: "",
      primaryColName: ""
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      let result = await reqDetail(this.id);
      if (result.resultCode == 10000) {
        this.content = result.result.content;
        this.title = result.result.title;
        this.data = result.result.effectStartTime;
        this.viewCount = result.result.viewCount || 1;
        this.infoSource = result.result.infoSource;
        this.secondaryColName = result.result.secondaryColName;
        this.primaryColName = result.result.primaryColName;
      }
      this.$emit("handleName", this.primaryColName, this.secondaryColName);
    }
  }
};
</script>

<style scoped lang="less">
.detail-content {
  padding: 24px 62px 40px 62px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  .content-head {
    padding-bottom: 24px;
    width: 100%;
    display: flex;
    align-items: center;
    border-bottom: 2px solid rgba(18, 68, 155, 0.2);
    img {
      width: 30px;
      height: 30px;
    }
    span {
      margin-left: 5px;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #0052d9;
      line-height: 34px;
    }
  }
  .noP {
    padding: 24px 0 !important;
  }
  .content-body {
    padding: 24px 60px;
    font-size: 16px;
    font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Arial,sans-serif;
    .head-text {
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        text-align: center;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 34px;
        // display: -webkit-box;
        // overflow: hidden; /*超出隐藏*/
        // text-overflow: ellipsis; /*隐藏后添加省略号*/
        // -webkit-box-orient: vertical;
        // -webkit-line-clamp: 1; /*想显示多少行*/
      }
    }
    .data-text {
      margin-top: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        margin-left: 10px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        line-height: 22px;
      }
    }
    .body-text {
      margin-top: 36px;
      /* 重置富文本中的元素样式 */
      /deep/ h1,
      /deep/ h2,
      /deep/ h3,
      /deep/ h4,
      /deep/ h5,
      /deep/ h6,
      /deep/ hr,
      /deep/ p,
      /deep/ blockquote,
      /deep/ dl,
      /deep/ dt,
      /deep/ dd,
      /deep/ ul,
      /deep/ ol,
      /deep/ li,
      /deep/ pre,
      /deep/ fieldset,
      /deep/ lengend,
      /deep/ button,
      /deep/ input,
      /deep/ textarea,
      /deep/ th,
      /deep/ td {
        margin: revert; /* 'revert' 将尝试恢复浏览器默认样式，如果不支持则使用 'initial' */
        padding: revert;
        // font-size: revert;
        /* 根据需要添加其他样式重置 */
      }

      /* 特定元素的样式调整 */
      /deep/ ul,
      /deep/ ol {
        list-style: revert;
      }

      /deep/ a {
        text-decoration: revert;
        color: revert; /* 或使用特定颜色 */
      }
      /deep/ table {
        border-top: 1px solid #000;
        border-left: 1px solid #000;
      }
      /deep/ table td,
      /deep/table th {
        border-bottom: 1px solid #000;
        border-right: 1px solid #000;
        padding: 3px 5px;
      }
      /deep/ table th {
        border-bottom: 2px solid #000;
        text-align: center;
      }
      /deep/ img {
        max-width: 100%;
        // max-height: 300px;
        height: auto !important;
      }
    }
  }
}

/* 大型桌面端样式 */
@media only screen and (min-width: 993px) {
  .detail-content {
    padding: 24px 62px 40px 62px;
    background: #ffffff;
    .content-head {
      padding-bottom: 24px;
      width: 100%;
      display: flex;
      align-items: center;
      border-bottom: 2px solid rgba(18, 68, 155, 0.2);
      img {
        width: 30px;
        height: 30px;
      }
      span {
        margin-left: 5px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0052d9;
        line-height: 34px;
      }
    }
    .noP {
      padding: 24px 0 !important;
    }
    .content-body {
      padding: 24px 60px;
      font-size: 16px;
      font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Arial,sans-serif;
      .head-text {
        display: flex;
        align-items: center;
        justify-content: center;
        p {
          text-align: center;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 34px;
          // display: -webkit-box;
          // overflow: hidden; /*超出隐藏*/
          // text-overflow: ellipsis; /*隐藏后添加省略号*/
          // -webkit-box-orient: vertical;
          // -webkit-line-clamp: 1; /*想显示多少行*/
        }
      }
      .data-text {
        margin-top: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          margin-left: 10px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
          line-height: 22px;
        }
      }
      .body-text {
        margin-top: 36px;
        /* 重置富文本中的元素样式 */
        /deep/ h1,
        /deep/ h2,
        /deep/ h3,
        /deep/ h4,
        /deep/ h5,
        /deep/ h6,
        /deep/ hr,
        /deep/ p,
        /deep/ blockquote,
        /deep/ dl,
        /deep/ dt,
        /deep/ dd,
        /deep/ ul,
        /deep/ ol,
        /deep/ li,
        /deep/ pre,
        /deep/ fieldset,
        /deep/ lengend,
        /deep/ button,
        /deep/ input,
        /deep/ textarea,
        /deep/ th,
        /deep/ td {
          margin: revert; /* 'revert' 将尝试恢复浏览器默认样式，如果不支持则使用 'initial' */
          padding: revert;
          // font-size: revert;
          /* 根据需要添加其他样式重置 */
        }

        /* 特定元素的样式调整 */
        /deep/ ul,
        /deep/ ol {
          list-style: revert;
        }

        /deep/ a {
          text-decoration: revert;
          color: revert; /* 或使用特定颜色 */
        }

        /deep/ table {
          border-top: 1px solid #000;
          border-left: 1px solid #000;
        }
        /deep/ table td,
        /deep/table th {
          border-bottom: 1px solid #000;
          border-right: 1px solid #000;
          padding: 3px 5px;
        }
        /deep/ table th {
          border-bottom: 2px solid #000;
          text-align: center;
        }
        /deep/ img {
          max-width: 100%;
          // max-height: 300px;
          height: auto !important;
        }
      }
    }
  }
}
</style>
